import { c as _c } from "react/compiler-runtime";
import type { BadgeType } from '@newfront-insurance/core-ui';
import { Badge, FeaturedCard } from '@newfront-insurance/core-ui';
import { PolicyStatus } from '@newfront-insurance/coverage-api';
import type { ClickHandler } from 'next-router-provider';
import type { JSX } from 'react';
import type { Policy } from '../../bff/types';
import renderPolicyName from '../../utils/render-policy-name';
import { PolicyDefinitionList } from '../policy-definition-list';
export interface Props {
  /** The policy to display */
  policy: Policy;
  /** If passed, clicking on the title will navigate to the provided href */
  href?: string;
  /** This is the target attribute that will work together with the href */
  target?: string;
  /** If passed, clicking on the Client Name will navigate to the provided href */
  accountHref?: string;
  /** Function to run when you Click on the Client Name */
  onAccountClick?: () => void;
  onClick?: ClickHandler;
  /** If passed, a button with type='close' button will render and will execute this function */
  onRemove?: (policy: Policy) => void;
  /** If passed, this function will run on card selection */
  onSelect?: (policy: Policy) => void;
  isSelected?: boolean;
  /** If true, a Chevron will render to allow expanding/collapsing the panel */
  isExpandable?: boolean;
  /** Whether the card comes expanded by default */
  defaultExpanded?: boolean;
  selectType?: 'radio' | 'checkbox';
  /** Short will remove the field titles and just displauy the values */
  variant?: 'default' | 'short';
}
export function PolicyCard(t0) {
  const $ = _c(30);
  const {
    policy,
    href,
    accountHref,
    onAccountClick,
    selectType: t1,
    target,
    isExpandable: t2,
    defaultExpanded: t3,
    isSelected,
    onClick,
    onSelect,
    onRemove,
    variant
  } = t0;
  const selectType = t1 === undefined ? "checkbox" : t1;
  const isExpandable = t2 === undefined ? false : t2;
  const defaultExpanded = t3 === undefined ? false : t3;
  const {
    details,
    definition,
    type,
    status
  } = policy;
  let badgeType;
  let badgeText;
  bb0: switch (status) {
    case PolicyStatus.ACTIVE:
      {
        badgeText = "Active";
        badgeType = "success";
        break bb0;
      }
    case PolicyStatus.CANCELLED:
      {
        badgeText = "Cancelled";
        badgeType = "danger";
        break bb0;
      }
    case PolicyStatus.EXPIRED:
      {
        badgeText = "Expired";
        badgeType = "info";
        break bb0;
      }
    case PolicyStatus.UPCOMING:
      {
        badgeText = "Upcoming";
        badgeType = "warning";
        break bb0;
      }
    default:
      {
        badgeText = undefined;
        badgeType = undefined;
      }
  }
  const t4 = definition?.readableName ?? type;
  let t5;
  if ($[0] !== details.displayName || $[1] !== t4) {
    t5 = renderPolicyName(t4, details.displayName);
    $[0] = details.displayName;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = variant === "short";
  let t7;
  if ($[3] !== accountHref || $[4] !== onAccountClick || $[5] !== policy || $[6] !== t6) {
    t7 = <PolicyDefinitionList policy={policy} accountHref={accountHref} onAccountClick={onAccountClick} hideTitle={t6} />;
    $[3] = accountHref;
    $[4] = onAccountClick;
    $[5] = policy;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== badgeText || $[9] !== badgeType) {
    t8 = badgeType ? <Badge type={badgeType}>{badgeText}</Badge> : null;
    $[8] = badgeText;
    $[9] = badgeType;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onSelect || $[12] !== policy) {
    t9 = onSelect ? () => onSelect(policy) : undefined;
    $[11] = onSelect;
    $[12] = policy;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== onRemove || $[15] !== policy) {
    t10 = onRemove ? () => onRemove(policy) : undefined;
    $[14] = onRemove;
    $[15] = policy;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== defaultExpanded || $[18] !== href || $[19] !== isExpandable || $[20] !== isSelected || $[21] !== onClick || $[22] !== selectType || $[23] !== t10 || $[24] !== t5 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9 || $[28] !== target) {
    t11 = <FeaturedCard eyebrow="Policy" title={t5} href={href} onClick={onClick} target={target} content={t7} badge={t8} isExpandable={isExpandable} defaultExpanded={defaultExpanded} onSelect={t9} onRemove={t10} isSelected={isSelected} selectType={selectType} />;
    $[17] = defaultExpanded;
    $[18] = href;
    $[19] = isExpandable;
    $[20] = isSelected;
    $[21] = onClick;
    $[22] = selectType;
    $[23] = t10;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = target;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}